"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.init = init;
exports._setCategoryId = _setCategoryId;
exports.setCategoryId = setCategoryId;
exports._setSubCategoryId = _setSubCategoryId;
exports.setSubCategoryId = setSubCategoryId;
exports.getRankMajorCategories = getRankMajorCategories;
exports.getRankMajorSubcat = getRankMajorSubcat;
exports.getRankMajorDetail = getRankMajorDetail;
/**
 * Created by brickspert on 17-5-11.
 */
var GET_RANK_MAJOR_CATEGORY = "api/rank/subject/GET_RANK_MAJOR_CATEGORY";
var GET_RANK_MAJOR_CATEGORY_SUCCESS = "api/rank/subject/GET_RANK_MAJOR_CATEGORY_SUCCESS";
var GET_RANK_MAJOR_CATEGORY_FAIL = "api/rank/subject/GET_RANK_MAJOR_CATEGORY_FAIL";

var GET_RANK_MAJOR_SUBCAT = "api/rank/major/GET_RANK_MAJOR_SUBCAT";
var GET_RANK_MAJOR_SUBCAT_SUCCESS = "api/rank/major/GET_RANK_MAJOR_SUBCAT_SUCCESS";
var GET_RANK_MAJOR_SUBCAT_FAIL = "api/rank/major/GET_RANK_MAJOR_SUBCAT_FAIL";

var GET_RANK_MAJOR_DETAIL = "api/rank/major/GET_RANK_MAJOR_DETAIL";
var GET_RANK_MAJOR_DETAIL_SUCCESS = "api/rank/major/GET_RANK_MAJOR_DETAIL_SUCCESS";
var GET_RANK_MAJOR_DETAIL_FAIL = "api/rank/major/GET_RANK_MAJOR_DETAIL_FAIL";

var SET_CATEGORY_ID = "api/rank/major/SET_CATEGORY_ID";
var SET_SUB_CATEGORY_ID = "api/rank/major/SET_SUB_CATEGORY_ID";

var initialState = {
    categories: [],
    categoryId: '',
    sub_categories: [],
    subCategoryId: '',
    detailLoading: false,
    detail: {
        subCategoryName: '',
        subCategoryIntro: '',
        list: []
    }
};
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_RANK_MAJOR_CATEGORY_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                categories: action.result.data.data
            });
        case GET_RANK_MAJOR_SUBCAT:
            return _extends({}, state, {
                sub_categories: []
            });
        case GET_RANK_MAJOR_SUBCAT_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                sub_categories: action.result.data.data
            });
        case GET_RANK_MAJOR_DETAIL:
            return _extends({}, state, {
                detailLoading: true
            });
        case GET_RANK_MAJOR_DETAIL_SUCCESS:
            if (!action.result.data.success) {
                return {
                    detailLoading: false
                };
            }
            return _extends({}, state, {
                detail: action.result.data.data,
                detailLoading: false
            });
        case GET_RANK_MAJOR_DETAIL_FAIL:
            return _extends({}, state, {
                detailLoading: false
            });
        case SET_CATEGORY_ID:
            return _extends({}, state, {
                categoryId: action.categoryId
            });
        case SET_SUB_CATEGORY_ID:
            return _extends({}, state, {
                subCategoryId: action.subCategoryId
            });
        default:
            return state;
    }
}

function init() {
    return function (dispatch) {
        dispatch(getRankMajorCategories());
        dispatch(_setCategoryId(1));
        dispatch(getRankMajorSubcat(1));
        dispatch(_setSubCategoryId(1));
        dispatch(getRankMajorDetail(1));
    };
}

function _setCategoryId(categoryId) {
    return {
        type: SET_CATEGORY_ID,
        categoryId: categoryId
    };
}

function setCategoryId(categoryId) {
    return function (dispatch, getState) {
        var rankMajor = getState().rankMajor;
        if (rankMajor.categoryId == categoryId) {
            dispatch(_setCategoryId(''));
        } else {
            dispatch(_setCategoryId(categoryId));
            dispatch(getRankMajorSubcat(categoryId));
        }
    };
}
function _setSubCategoryId(subCategoryId) {
    return {
        type: SET_SUB_CATEGORY_ID,
        subCategoryId: subCategoryId
    };
}

function setSubCategoryId(subCategoryId) {
    return function (dispatch) {
        dispatch(_setSubCategoryId(subCategoryId));
        dispatch(getRankMajorDetail(subCategoryId));
    };
}
function getRankMajorCategories() {
    return {
        types: [GET_RANK_MAJOR_CATEGORY, GET_RANK_MAJOR_CATEGORY_SUCCESS, GET_RANK_MAJOR_CATEGORY_FAIL],
        promise: function () {
            function promise(client) {
                return client.get("/api/rank/major/category");
            }

            return promise;
        }()
    };
}
function getRankMajorSubcat(categoryId) {
    return {
        types: [GET_RANK_MAJOR_SUBCAT, GET_RANK_MAJOR_SUBCAT_SUCCESS, GET_RANK_MAJOR_SUBCAT_FAIL],
        promise: function () {
            function promise(client) {
                return client.get("/api/rank/major/sub_category?categoryId=" + categoryId);
            }

            return promise;
        }()
    };
}

function getRankMajorDetail(subCatId) {
    return {
        types: [GET_RANK_MAJOR_DETAIL, GET_RANK_MAJOR_DETAIL_SUCCESS, GET_RANK_MAJOR_DETAIL_FAIL],
        promise: function () {
            function promise(client) {
                return client.get("/api/rank/major/school?subCategoryId=" + subCatId);
            }

            return promise;
        }()
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/rank/rankMajor.js
// module id = 493
// module chunks = 0